import type { NotifiableError } from "@bugsnag/js";
import type { BugsnagMetadata } from "@/react/helpers/bugsnagHelpers";
import { notifyBugsnag } from "@/react/helpers/bugsnagHelpers";
import { isDevelopmentEnv } from "@/react/helpers/envHelpers";

export interface ReportCheckoutErrorData {
  caller?: string;
  communityId?: number;
  communityMemberId?: number;
  communityMemberUserId?: number;
  extra: Record<string, unknown>;
  paywallId?: number;
  stripeElementsMode?: string;
  stripePaymentMethodType?: string;
}
export const reportCheckoutError = (
  error: unknown,
  data: ReportCheckoutErrorData,
) => {
  const bugsnagMetadata: BugsnagMetadata = {
    checkout: {
      ...data.extra,
      caller: data.caller,
      community_id: data.communityId,
      community_member_id: data.communityMemberId,
      community_member_user_id: data.communityMemberUserId,
      paywall_id: data.paywallId,
      stripe_elements_mode: data.stripeElementsMode,
      stripe_payment_method_type: data.stripePaymentMethodType,
      url: window.location.href,
    },
  };
  notifyBugsnag(error as NotifiableError, bugsnagMetadata);

  if (isDevelopmentEnv()) {
    console.error(error, data);
  }
};
